import { render, staticRenderFns } from "./personnelChange.vue?vue&type=template&id=61f929ea&scoped=true"
import script from "./personnelChange.vue?vue&type=script&lang=js"
export * from "./personnelChange.vue?vue&type=script&lang=js"
import style0 from "./personnelChange.vue?vue&type=style&index=0&id=61f929ea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f929ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f929ea')) {
      api.createRecord('61f929ea', component.options)
    } else {
      api.reload('61f929ea', component.options)
    }
    module.hot.accept("./personnelChange.vue?vue&type=template&id=61f929ea&scoped=true", function () {
      api.rerender('61f929ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/components/personnelChange.vue"
export default component.exports